import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchPatientAppointments = async ({ patientId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${__API_URL__}/api/appointments/appointments/patient/?PatientId=${patientId}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetPatientAppointments = ({ patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["patient_appointments", patientId],
    queryFn: () => fetchPatientAppointments({ patientId }),
    enabled: enabled && Boolean(patientId),
  });
};

export default useGetPatientAppointments;
